import { render, staticRenderFns } from "./LinkedDepartmentsComponent.vue?vue&type=template&id=2497f160&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./LinkedDepartmentsComponent.vue?vue&type=script&lang=js&"
export * from "./LinkedDepartmentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./LinkedDepartmentsComponent.vue?vue&type=style&index=0&id=2497f160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497f160",
  null
  
)

component.options.__file = "LinkedDepartmentsComponent.vue"
export default component.exports